export const CRegexp = {
  ID: /^\d{11}$/,
  RNC: /^\d{9}$/,
  PASSPORT: /^[a-zA-Z0-9]{7,15}$/,
  PHONE: /^\d{10}$/,
  URL: /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?(\/\S*)?$/,
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  NUMBER_MAYOR_CERO:
    /^(?!0+$)(?!0(?:\.0+)?$)(?!0+\.\d*$)(?:[1-9]\d{0,2}(?:,\d{3})*|\d+)(?:\.\d+)?$/,
  PERCENT: /^(\d{1,2}(\.\d{1,2})?|100(\.0{1,2})?)$/,
  YOUTUBE_URL: /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/
};

export { CRegexp as default };
